<template>
  <div class="textarea">
    <div :class="['textarea__message', error && !hasFocus ? 'textarea__message--error' : 'textarea__message--label']">
      <span v-if="hasFocus">{{ altLabel }}</span>
      <span v-else>{{ error ? error : label }}</span>
    </div>

    <div
      class="textarea__field"
      @click="$refs[refName].focus()"
    >
      <textarea
        :ref="refName"
        v-model="input"
        :placeholder="placeholder"
        :disabled="disabled"
        :autofocus="autofocus"
        :class="['textarea__element', status === 'invalid' ? 'textarea__element--error' : '', status === 'valid' && input.length > 0 ? 'textarea__element--success' : '', hasFocus ? 'textarea__element--active' : '']"
        @focus="hasFocus = true"
        @blur="hasFocus = false; $emit('unfocused')"
        @keyup="$emit('input', input); $emit('change')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    refName: {
      type: String,
      default: 'input'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    altLabel: {
      type: String,
      default: ''
    },
    error: {
      type: [String, Boolean],
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    status: {
      type: [String, Boolean],
      default: false
    }
  },
  data () {
    return {
      input: this.value,
      hasFocus: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.textarea {
  position: relative;
  width: 100%;

  &__message {
    position: relative;
    width: 100%;
    text-align: left;

    &--label {
      color: rgba($white, 0.9);
    }

    &--error {
      color: $danger;
    }
  }

  &__field {
    position: relative;
    top: 0;
    left: 0;
    height: 6rem;
    width: 100%;

    &:hover {
      .textarea__icon {
        fill: $white;
      }

      .textarea__element:not(.textarea__element--active):not(.textarea__element--success):not(.textarea__element--error) {
        background-color: $bg-1;
        border-color: rgba($white, 0.4);
      }
    }
  }

  &__element {
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    width: calc(100% - 1.25rem);
    height: 5rem;
    padding: 0.5rem;
    outline: 0;
    border-radius: 0.25rem;
    border-style: solid;
    border-color: $bg-1;
    border-width: 0 0 0 0.25rem;
    background-color: $bg-1;
    transition: background-color 0.2s ease-out, border 0.2s ease-out;
    color: #fff;

    &::placeholder {
      color: rgba($white, 0.3);
    }

    &:focus, &:active, &--active {
      border-radius: 0 0.25rem 0.25rem 0;
      color: $white;
      border-color: rgba($white, 0.9);
    }

    &:disabled {
      background-color: lighten($bg-2, 25);
      border-color: lighten($bg-2, 25);
    }

    &--success {
      border-radius: 0 0.25rem 0.25rem 0;
      color: $white;
      border-color: $success;
    }

    &--error {
      border-radius: 0 0.25rem 0.25rem 0;
      color: $white;
      border-color: $danger;
    }
  }
}

:-webkit-autofill {
  box-shadow: 0 0 0 100rem $bg-2 inset !important;
  -webkit-text-fill-color: $white !important;
}

</style>
